export default __webpack_public_path__ + "img/94e57a5e75a94d80068ebbfe260fc7de.svg";